import { render, staticRenderFns } from "./RevenueNowCompare.vue?vue&type=template&id=df9a0ca0&scoped=true"
import script from "./RevenueNowCompare.vue?vue&type=script&lang=ts"
export * from "./RevenueNowCompare.vue?vue&type=script&lang=ts"
import style0 from "./RevenueNowCompare.vue?vue&type=style&index=0&id=df9a0ca0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9a0ca0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df9a0ca0')) {
      api.createRecord('df9a0ca0', component.options)
    } else {
      api.reload('df9a0ca0', component.options)
    }
    module.hot.accept("./RevenueNowCompare.vue?vue&type=template&id=df9a0ca0&scoped=true", function () {
      api.rerender('df9a0ca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/RevenueNowCompare.vue"
export default component.exports